import React, { Component } from "react";
import { toLiteral } from "../../../../../helper/locale-utils";
import "./filter-summary.scss";

interface FiltersSummaryProps {
  filterValues: any;
  clearFieldValue: Function;
  nonClosableFilters: string[];
}
class FiltersSummary extends Component<FiltersSummaryProps> {
  nonClosableFilters = this.props.nonClosableFilters || [];

  handleRenderArray = (filterKey: any, value: any) => {
    const allSpans: any[] = [];
    if (value && value.length) {
      value.forEach((item: any) => {
        const data = [filterKey, item];
        const textToShow = typeof item === "string" ? toLiteral({ id: item }) : JSON.stringify(item);
        const itemToAdd = !this.nonClosableFilters.includes(item) ? (
          <div key={filterKey + item} className="chip-item">
            <button type="button" onClick={(e) => this.props.clearFieldValue(data)} data-key={""} className="chip">
              {toLiteral({ id: filterKey })}: <strong>{textToShow}</strong>
              <span className="material-icons right">close</span>
            </button>
          </div>
        ) : (
          <div key={filterKey + item} className="chip-item">
            <button type="button" data-key={""} className="chip nonClicable">
              {toLiteral({ id: filterKey })}: <strong>{textToShow}</strong>
            </button>
          </div>
        );

        allSpans.push(itemToAdd);
      });
    }

    return allSpans;
  };

  render() {
    const arr = [];
    if (this.props.filterValues) {
      for (let key in this.props.filterValues) {
        if (this.props.filterValues.hasOwnProperty(key)) {
          const value = this.props.filterValues[key];
          if (key && key.indexOf("_label") === -1) {
            if (value) {
              if (typeof value === "object") {
                arr.push(this.handleRenderArray(key, value));
              } else {
                const _idFilterName = key === "processTemplates" ? "process.templates" : key;
                const _idFilterValue = typeof value === "string" ? toLiteral({ id: value }) : JSON.stringify(value).replace(/(['"])/g, "");
                const itemToAdd = !this.nonClosableFilters.includes(key) ? (
                  <div key={key} className="chip-item">
                    <button
                      type="button"
                      className="chip"
                      onClick={(e: React.MouseEvent<HTMLButtonElement>) => this.props.clearFieldValue((e.currentTarget.attributes as any)["data-key"].value)}
                      data-key={key}
                    >
                      {toLiteral({ id: _idFilterName })}: <strong>{toLiteral({ id: _idFilterValue })}</strong>
                      <span className="material-icons right">close</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <div key={key} className="chip-item">
                      <button data-key={key} className="nonClicable">
                        {toLiteral({ id: _idFilterName })}: <strong>{toLiteral({ id: _idFilterValue })}</strong>
                      </button>
                    </div>
                  </>
                );
                arr.push(itemToAdd);
              }
            }
          }
        }
      }
      return <div className="chips-group">{arr}</div>;
    }
    return null;
  }
}

export default FiltersSummary;
